import { render, staticRenderFns } from "./PatientDetailHeader.vue?vue&type=template&id=c5972dba&scoped=true&"
import script from "./PatientDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./PatientDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDetailHeader.vue?vue&type=style&index=0&id=c5972dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5972dba",
  null
  
)

export default component.exports